import type { JobListResponse, JobDetail } from '@/types'

const NODE1 = 'aaaaaaaa-0001-0001-0001-000000000001'
const NODE2 = 'aaaaaaaa-0002-0002-0002-000000000002'
const NODE3 = 'aaaaaaaa-0003-0003-0003-000000000003'

const MOCK_JOBS_DATA: JobDetail[] = [
  {
    id: 'jjjjjjjj-0001-0001-0001-000000000001',
    command_id: 'cccccccc-0001-0001-0001-000000000001',
    node_id: NODE1,
    node_name: 'Pohang sealing left',
    node_key: 'pohang-sealing-left',
    node_site: 'Pohang',
    node_company: 'Sungshin',
    type: 'recording',
    status: 'running',
    camera_key: 'cam0',
    progress: null,
    config_revision: 3,
    requested_by: 'operator',
    error_message: null,
    started_at: new Date(Date.now() - 600000).toISOString(),
    finished_at: null,
    pid: 12345,
    log_tail: '[2026-05-19 09:00:05] Recording started: /data/manual/cam0/\n[2026-05-19 09:01:00] Chunk 1 written: 20260519_090000.mp4 (512 frames)\n[2026-05-19 09:02:00] Chunk 2 written: 20260519_090100.mp4 (512 frames)\n[2026-05-19 09:10:00] Disk free: 128GB / threshold: 20GB - OK',
  },
  {
    id: 'jjjjjjjj-0002-0002-0002-000000000002',
    command_id: 'cccccccc-0004-0004-0004-000000000004',
    node_id: NODE3,
    node_name: null,
    node_key: 'danyang-kiln-05',
    node_site: 'Danyang',
    node_company: 'Sungshin',
    type: 'upload',
    status: 'succeeded',
    camera_key: null,
    progress: 100,
    config_revision: 3,
    requested_by: 'admin',
    error_message: null,
    started_at: new Date(Date.now() - 1800000).toISOString(),
    finished_at: new Date(Date.now() - 900000).toISOString(),
    pid: null,
    log_tail: '[2026-05-19 09:00:00] Start uploading 1 files...\n[2026-05-19 09:00:01] [1 / 1] Uploading 20260519_100000.mp4\n[2026-05-19 09:15:00] Finished transfer in 900.2s',
  },
  {
    id: 'jjjjjjjj-0003-0003-0003-000000000003',
    command_id: null,
    node_id: NODE2,
    node_name: 'Gaya BCT exit camera with very long operation name',
    node_key: 'gaya-bct-exit-left',
    node_site: 'Gaya',
    node_company: 'Hanil',
    type: 'upload',
    status: 'failed',
    camera_key: null,
    progress: 42,
    config_revision: 2,
    requested_by: null,
    error_message: 'connection reset by peer while uploading /recording/done/jjjjjjjj-0003/20260518_143000.mp4 to ftp://nas.internal.example/upload/gaya-bct-exit-left/20260518/. retry_count=3 last_errno=ECONNRESET',
    started_at: new Date(Date.now() - 7200000).toISOString(),
    finished_at: new Date(Date.now() - 7000000).toISOString(),
    pid: null,
    log_tail: '[2026-05-19 07:00:00] Start uploading 2 files...\n[2026-05-19 07:01:00] [1 / 2] Uploading 20260518_143000.mp4\n[2026-05-19 07:03:20] Failed to sync directory: connection reset by peer',
  },
]

export function mockJobs(params?: {
  node_id?: string
  status?: string
  type?: string
  started_from?: string
  started_to?: string
  limit?: number
  offset?: number
}): JobListResponse {
  let items: JobDetail[] = MOCK_JOBS_DATA
  if (params?.node_id) items = items.filter((j) => j.node_id === params.node_id)
  if (params?.status) items = items.filter((j) => j.status === params.status)
  if (params?.type) items = items.filter((j) => j.type === params.type)
  if (params?.started_from) {
    const startedFrom = new Date(params.started_from).getTime()
    items = items.filter((j) => j.started_at != null && new Date(j.started_at).getTime() >= startedFrom)
  }
  if (params?.started_to) {
    const startedTo = new Date(params.started_to).getTime()
    items = items.filter((j) => j.started_at != null && new Date(j.started_at).getTime() <= startedTo)
  }
  const total = items.length
  const offset = params?.offset ?? 0
  if (offset) items = items.slice(offset)
  if (params?.limit != null) items = items.slice(0, params.limit)
  return { items, total }
}

export function mockJobDetail(jobId: string): JobDetail {
  return MOCK_JOBS_DATA.find((j) => j.id === jobId) ?? {
    id: jobId,
    command_id: null,
    node_id: '',
    node_name: null,
    node_key: null,
    node_site: null,
    node_company: null,
    type: 'recording',
    status: 'failed',
    camera_key: null,
    progress: null,
    config_revision: null,
    requested_by: null,
    error_message: null,
    started_at: null,
    finished_at: null,
    pid: null,
    log_tail: null,
  }
}
